import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "9", y2: "13", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12.01", y1: "17", y2: "17", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "AlertTriangle";
const AlertTriangle = memo(themed(Icon));
export {
  AlertTriangle
};
//# sourceMappingURL=alert-triangle.js.map
